import { Injectable, inject } from '@angular/core';
import {
  DocumentManagementApi,
  type DocumentManagementSettings,
} from '@tourfold/libraries/tf-api-client-public-v2';

/**
 * Thin wrapper over the generated `DocumentManagementApi`. Exposes a promise-first
 * facade matching the rest of the document-management services.
 */
@Injectable({ providedIn: 'root' })
export class DocumentManagementSettingsService {
  private readonly api = inject(DocumentManagementApi);

  get(): Promise<DocumentManagementSettings> {
    return this.api.getDocumentManagementSettings();
  }

  /**
   * Update the auto-hard-delete retention. Backend rejects out-of-range values with
   * `document-management/invalid-retention-days` (HTTP 422); callers should funnel that through
   * `translateProblem` to surface the inline error.
   */
  setAutoHardDeleteAfterDays(days: number): Promise<DocumentManagementSettings> {
    return this.api.updateDocumentManagementSettings({
      patchDocumentManagementSettings: {
        autoHardDeleteAfterDays: days,
      },
    });
  }
}
